// The donate button.
//
// It says "Donate here :)" rather than naming the service, because what is
// being asked for is a donation and Buy Me a Coffee is only where it lands.
// The BRANDING still does the work of making the link trustworthy — their
// yellow, their cup — so somebody who recognises it knows where they are going
// before they tap, and somebody who does not is told plainly what it is for.
//
// The URL is a PROP and not a constant in here. Where the money goes is the
// host's business — this folder is a copy-out of UMapsTools and a donation link
// baked into it would follow the map into somebody else's app, which is the one
// kind of hardcoded URL that is not merely untidy. Same rule `appPromo` follows.
//
// Buy Me a Coffee's own brand is a yellow button with a cup on it, and that
// recognisability is most of what makes somebody trust the link — so the colour
// is theirs (#FFDD00 on black text) and the cup is drawn here rather than
// loaded from their CDN. A remote image would be a third-party request on
// first paint, and it would leave a blank yellow rectangle on the visits where
// it fails.
// Copy-out clean: no imports outside src/pathfinder.

// ⚠️ The smiley is literal ASCII and is meant to be. It is the one warm thing
// on a button that is asking for money, an emoji would render as somebody
// else's yellow face beside their yellow cup, and ":)" is what the person whose
// project this is actually types.
export default function DonateButton({ href, label = 'Donate here :)' }) {
  if (!href) return null;
  return (
    <a className="pfa-fb-bmc" href={href} target="_blank" rel="noopener noreferrer">
      <CoffeeCup />
      {label}
    </a>
  );
}

/** A cup, a saucer and two curls of steam — their mark, at this stroke weight. */
function CoffeeCup() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9z" />
      <path d="M16 10.5h1.6a2.6 2.6 0 0 1 0 5.2H16" />
      <path d="M8 3.2c-.6.8-.6 1.5 0 2.3M12 3.2c-.6.8-.6 1.5 0 2.3" />
    </svg>
  );
}
